<template>
    <div id="app">
      <router-view/>
    </div>
</template>

<script>

export default {
  data () {
    return {}
  },
  name: 'App',
  methods: {
    setCaretPosition(ctrl, pos) {
        // Modern browsers
        if (ctrl.setSelectionRange) {
            ctrl.focus();
            ctrl.setSelectionRange(pos, pos)
        // IE8 and below
        } else if (ctrl.createTextRange) {
            var range = ctrl.createTextRange()
            range.collapse(true)
            range.moveEnd('character', pos)
            range.moveStart('character', pos)
            range.select()
        }
    }
  },
  mounted() {
    window.addEventListener('keyup', event => {
      if (event.keyCode === 9) {
        setTimeout(() => {
            if (
                document.activeElement &&
                document.activeElement.type == "text" &&
                document.activeElement.value.includes('0,00') &&
                document.activeElement.value.startsWith('0')
            ) {
                this.setCaretPosition(document.activeElement, document.activeElement.value.indexOf(','))
            }
        }, 250);
      }
    })
  }
}
</script>
